import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  const scrollToHashTarget = (hashValue: string) => {
    const id = hashValue.replace("#", "");
    const target = document.getElementById(id);

    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (hash && scrollToHashTarget(hash)) {
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  useEffect(() => {
    const handleSupportUsClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const anchor = target?.closest('a[href*="#donate"]') as
        | HTMLAnchorElement
        | null;

      if (!anchor) {
        return;
      }

      const href = anchor.getAttribute("href") || "";
      const isHomeSupportLink =
        href === "/home#donate" || href.endsWith("#donate");

      if (!isHomeSupportLink) {
        return;
      }

      // If we are already on the same route/hash, router location won't change,
      // so trigger smooth scroll manually.
      if (window.location.pathname === "/home" && window.location.hash === "#donate") {
        const didScroll = scrollToHashTarget("#donate");
        if (didScroll) {
          event.preventDefault();
        }
      }
    };

    document.addEventListener("click", handleSupportUsClick);
    return () => document.removeEventListener("click", handleSupportUsClick);
  }, []);

  return null;
};

export default ScrollToTop;
